import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const LightningBoltFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="lightningBoltFilled" ref={ref} {...props}>
    <path d="M5.81,22a.83.83,0,0,1-.42-.13A.76.76,0,0,1,5.11,21l3-8H6.94a.76.76,0,0,1-.64-.36.73.73,0,0,1,0-.73l4.5-9a.74.74,0,0,1,.67-.41h6.75a.74.74,0,0,1,.62,1.16L15.09,9.27h3.1a.75.75,0,0,1,.7.47.76.76,0,0,1-.2.83L6.32,21.82A.78.78,0,0,1,5.81,22Z" />
  </Icon>
)) as IconWithRender;

LightningBoltFilledIcon.displayName = 'LightningBoltFilledIcon';
LightningBoltFilledIcon.renderIcon = (props) => (
  <LightningBoltFilledIcon {...props} />
);
export default LightningBoltFilledIcon;
